import {Checkbox, FormControlLabel} from "@mui/material";
import {FormattedMessage} from "react-intl";

type Props = {
    state: boolean;
    setState: (v: boolean) => void;
};

export default ({state, setState}: Props) => (
    <FormControlLabel
        control={<Checkbox checked={state} onChange={(ev) => setState(ev.target.checked)} color="primary" />}
        label={<FormattedMessage id="createAnother" defaultMessage="Create another" />}
    />
);
